
// import the interface

import { loadDataActionType,LoadDataAction } from '../actions/load-data.action';
import { LoadData } from '../models/load-data.model';

//create a dummy initial state
const initialState: LoadData ={
  loaded:true,
  typeReload:"",
  loadingEnd:"unload"
};
export function loadDataReducer(state: LoadData = initialState,action: LoadDataAction) {
  switch (action.type) {
    case loadDataActionType.LOAD:
        if(action.payload.loadingEnd)
        {
          return {
          ...state,
          loaded:action.payload.loaded,
          typeReload:action.payload.typeReload,
          loadingEnd:action.payload.loadingEnd
          }
        }else{
          return {
            ...state,
            loaded:action.payload.loaded,
            typeReload:action.payload.typeReload
            }
        }
        
      
      
    default:
      return state;
  }
}
